import _extends from "@babel/runtime/helpers/esm/extends";
import { EditOutlined } from '@ant-design/icons';
import { ProCard } from '@ant-design/pro-components';
import { Button } from 'antd';
import React from 'react';
import { useStyles } from "./Card.style";
export var SuperCreatorCard = function SuperCreatorCard(properties) {
  var _useStyles = useStyles(),
    styles = _useStyles.styles;
  return /*#__PURE__*/React.createElement(ProCard, _extends({
    bordered: true,
    headerBordered: true,
    className: properties.for !== undefined ? styles.container : undefined,
    extra: properties.for !== undefined && /*#__PURE__*/React.createElement(Button, {
      onClick: function onClick() {
        var _properties$onCurrent;
        return (_properties$onCurrent = properties.onCurrentChange) === null || _properties$onCurrent === void 0 ? void 0 : _properties$onCurrent.call(properties, properties.for);
      },
      size: "small",
      icon: /*#__PURE__*/React.createElement(EditOutlined, null),
      type: "link"
    })
  }, properties, {
    bodyStyle: properties.bodyStyle || {
      paddingBlock: 'unset',
      paddingBlockStart: 24
    }
  }));
};
SuperCreatorCard.isProCard = true;